<template>

  <Form :model="formData" :label-width="100"  :rules="formRules" ref="formData">
      <FormItem label="大类" prop="bigCategoryCode">
            <Select :disabled="disabled" :label-in-value="true" v-model="formData.bigCategoryCode" class="item-width" @on-change="changeBigCategory">
              <Option value="">请选择</Option>
                <Option v-for="item in bigCategoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="小类" prop="smallCategoryCode">
            <Select :disabled="disabled" :label-in-value="true" v-model="formData.smallCategoryCode" class="item-width"  @on-change="changeSmallCategory">
              <Option value="">{{formData.bigCategoryCode==='' ? '请先选择大类':(smallCategoryList.length===0?'暂无数据':'请选择')}}</Option>
                <Option v-for="item in smallCategoryList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>
        <FormItem label="物品名称" prop="goodsCode">
            <Select :disabled="disabled" v-model="formData.goodsCode" :label-in-value="true" @on-change="getGoodsName" class="item-width" >
              <Option value="">{{formData.smallCategoryCode==='' ? '请先选择小类': (goodsList.length===0?'暂无数据':'请选择') }}</Option>
                <Option v-for="item in goodsList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
        </FormItem>

      <FormItem label="物品编码" v-if="modify">
          <Input v-model="formData.goodsArchivesCode" class="item-width" :disabled="true"></Input>
      </FormItem>

      <FormItem label="条形码">
          <Input v-model="formData.barCode" class="item-width" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="供应商" prop="configVendorCode">
          <Select :disabled="disabled" :label-in-value="true" v-model="formData.configVendorCode" class="item-width" @on-change="changeSupplier">
            <Option value="">请选择</Option>
              <Option v-for="item in supplierList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="品牌" prop="brand">
          <Select :disabled="disabled" v-model="formData.brand" class="item-width">
            <Option value="">{{ formData.configVendorCode === '' ? '请先选择供应商' : (brandList.length===0?'暂无':'请选择')}}</Option>
              <Option v-for="item in brandList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="是否可移动" prop="isFixed">
          <Select v-model="formData.isFixed" class="item-width" :disabled="disabled">
              <Option value="">请选择</Option>
              <Option v-for="item in isFixed" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="是否有遥控器" prop="telecontroller">
          <Select v-model="formData.telecontroller" class="item-width" :disabled="disabled">
              <Option value="">请选择</Option>
              <Option v-for="item in telecontroller" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="型号">
          <Input v-model="formData.specification" class="item-width" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="材质">
          <Input v-model="formData.material" class="item-width" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="尺寸">
          <Input v-model="formData.goodSize" class="item-width" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="取得方式" prop="channel" >
          <Select v-model="formData.channel" class="item-width" :disabled="disabled">
              <Option value="">请选择</Option>
              <Option v-for="item in channel" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="物品归属" prop="goodsBelong">
          <Select v-model="formData.goodsBelong" class="item-width" :disabled="disabled">
              <Option value="">请选择</Option>
              <Option v-for="item in goodsBelong" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="所属项目" prop="projectId">
          <Select v-model="formData.projectId" @on-change="changeProject" class="item-width" :disabled="disabled">
              <Option value="">请选择</Option>
              <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="配置区域" prop="configArea">
          <Select v-model="formData.configArea" class="item-width"  :disabled="disabled" @on-change="setConfigAreaFid">
              <Option value=''>请选择</Option>
              <Option v-for="item in configArea" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem v-show="formData.configArea" :label="formData.configArea===2?'功能区':'房间号'" prop="configAreaFid" >
          <Select v-if="formData.configArea===2" key="functionalArea" v-model="formData.configAreaFid" filterable :placeholder="fnAreaOptionLabel" class="item-width"  :disabled="disabled">
              <Option value="">{{add? (formData.projectId==='' ? '请先选择项目': (fnAreaList.length === 0?'暂无数据':'请选择')): fnAreaOptionLabel}}</Option>
              <Option v-for="item in fnAreaList" :value="item.value" :key="item.value">{{ item.text }}</Option>
          </Select>
          <Select
          key="room"
          class="item-width"
          :disabled="disabled"
          v-if="formData.configArea===1"
          v-model="formData.configAreaFid"
          filterable
          remote
          :remote-method="remoteMethod"
          :loading="loading"
          :label="label"
          :placeholder="formData.projectId==='' ?'请先选择项目':'请输入想查询的房间号'">
            <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
      </FormItem>
      <FormItem label="配置日期" prop="initiatTime">
          <DatePicker ref="initiatTime" :disabled="disabled" type="date" :options="initiatTime"  v-model="formData.initiatTime" @on-change="formData.initiatTime=$event" placeholder="yyyy-mm-dd" class="item-width"></DatePicker>
      </FormItem>
      <FormItem label="采购成本 (元)" prop="configCost">
          <Input v-model="formData.configCost" class="item-width" :number="true" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="配置成本 (元)" prop="valuation">
          <Input v-model="formData.valuation" class="item-width" :number="true" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="质保金 (元)" prop="warrantyMoney">
          <Input v-model="formData.warrantyMoney" class="item-width" :disabled="disabled"></Input>
      </FormItem>
      <FormItem label="截保日期">
          <DatePicker ref="qualifyDateStr" :disabled="disabled" type="date" placement="top" :options="insuranceDeadLine" v-model="formData.qualifyDateStr" @on-change="formData.qualifyDateStr=$event" :placeholder="disabled?'':'yyyy-mm-dd'" class="item-width"></DatePicker>
      </FormItem>
      <FormItem v-if="!disabled">
          <Button type="primary" @click="handleSubmit('formData')">保存</Button>
      </FormItem>
  </Form>

</template>

<script type="text/ecmascript-6">

import { getSelectedData,addArchives,updateArchives } from 'api/archives.js'
import { getFnByProject,getBuildInfo,fuzzyRoom } from 'api/functionalArea'
import { getSuppliers,getBrand } from 'api/supplier'
import { goodsInfoMenu,goodsInfoList} from 'api/goods'
export default {

  props:{
    disabled:{
      type:Boolean,
      default:false
    },
    add:{
      type:Boolean,
      default:false
    },
    modify:{
      type:Boolean,
      default:false
    },
    goodsData:{
      type: Object,
      default:null
    },
    n:{
      type:Number,
      default:0
    }
  },
  created() {
    this.initData()
      .then(() => {
        if(this.goodsData){
          for (var key in this.goodsData) {
            if(key === 'warrantyMoney'&& (this.goodsData[key]===0|| this.goodsData[key]===null)) {
              this.formData[key] = ''
            }else{
              this.formData[key] = this.goodsData[key]
            }
          }
          this.label = this.formData.configAreaExpr
          this.configAreaFid = this.formData.configAreaFid
        }

      })
  },
  beforeDestroy(){
    for (let key in this.formData) {
      this.formData[key] = ''
    }
  },
  watch:{
    goodsData: {
      deep: true,
      handler(val) {
        if(val){
          for (var key in val) {
            if(key === 'warrantyMoney'&& val[key]===0) {
              this.formData[key] = ''
            }else{
              this.formData[key] = val[key]
            }
          }
        }
      }
    },
    configAreaFid(val){
      if(this.formData.configArea===2){
        let configArea = this.fnAreaList.find(item => {
            return item.value === val
          })
        this.configAreaIsDel = configArea === undefined ? true : false
        this.fnAreaOptionLabel = this.getFnAreaOptionLabel()
      }
    }
  },
  data () {
    const validateDate = (rules,value,callback)=>{
      rules.type = typeof value === 'object' ? 'object':'string'
      if(!value){
        callback(new Error('请选择配置日期'));
      }
      callback();
    }
    const validatePrice = (rules,value,callback) => {
      if(!rules.required && value===''){
        callback();
      } else if( typeof value !=='number' || value <= 0){
        callback(new Error('请输入大于0的数字'));
      }
      callback();
    }
    const validateWarrantyMoney = (rules,value,callback) => {
      const pattern = /^(?:[1-9][0-9]*\.[0-9]+|0\.(?!0+$)[0-9]+|[1-9]+\d*)$/
      if(value !=='' && !pattern.test(value)){
        callback(new Error('请输入大于0的数字'));
      }
      callback();
    }

    const validateConfigAreaFid = (require,value,callback) => {
      if(this.formData.configArea===1 && value===''){
        callback(new Error('请输入房间号'))
      } else if (this.formData.configArea===2 && value==='') {
        callback(new Error('请选择功能区'))
      }
      callback()
    }
    return {
      isFirstChang:true,
      loading:false,
      label:'',
      fnAreaOptionLabel:'',
      configAreaIsDel:false,
      configAreaFid:'',
      bigCategoryList:[],
      smallCategoryList:[],
      goodsList:[],
      supplierList:[],
      brandList:[],
      isFixed:[],
      telecontroller:[],
      channel:[],
      goodsBelong:[],
      projectList:[],
      roomList:[],
      fnAreaList:[],
      configArea:[],
      formData:{
        barCode:'',
        bigCategoryCode: '',
        bigCategoryName:'',
        brand:'',
        channel: '',
        configArea: '',
        configAreaFid:'',
        configCost: '',
        configVendorCode: '',
        configVendorName: '',
        goodSize: '',
        goodsBelong: '',
        goodsCode: '',
        goodsName: '',
        // goodsArchivesCode:'',
        initiatTime: '',
        isFixed: '',
        material:'',
        projectId: '',
        qualifyDateStr: '',
        smallCategoryCode: '',
        smallCategoryName: '',
        specification: '',
        telecontroller: '',
        valuation: '',
        warrantyMoney:''
      },
      insuranceDeadLine: {
        disabledDate (date) {
            return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      initiatTime:{
        disabledDate (date) {
            return date && date.valueOf() > Date.now();
        }
      },
      formRules:{
        bigCategoryCode:[{ required: true, type:'string',message:'请选择大类名称',trigger: 'change'}],
        smallCategoryCode:[{ required: true, type:'string',message:'请选择小类名称',trigger: 'change'}],
        goodsCode:[
          { required: true, type:'string',message:'请选择物品名称',trigger: 'change'}
        ],
        configVendorCode:[
          { required: true, type:'string',message:'请选择供应商',trigger: 'change'}
        ],
        brand:[
          { required: true, type:'string',message:'请选择物品品牌',trigger: 'change'}
        ],
        isFixed:[
          { required: true, type:'number',message:'请选择是否可移动',trigger: 'change'}
        ],
        telecontroller:[
          { required: true, type:'number', message:'请选择是否有遥控器', trigger:'change'}
        ],
        channel:[
          { required: true, type:'number', message:'请选择取得方式', trigger:'change'}
        ],
        goodsBelong:[
          { required: true, type:'number', message:'请选择物品归属', trigger:'change'}
        ],
        projectId:[
          { required: true, type:'string', message:'请选择所属项目', trigger:'change'}
        ],
        configArea: [{required: true, message:'请选择配置区域',type:'number',trigger:'change'}],
        configAreaFid: [{required: true, validator:validateConfigAreaFid,type:'string',trigger:'change'}],
        configCost: [{required: true, validator:validatePrice,  trigger:'blur'}],
        warrantyMoney: [{ validator:validateWarrantyMoney, type:'number', trigger:'blur'}],
        valuation: [{ required: true, validator:validatePrice, trigger:'blur'}],
        initiatTime: [{required: true, validator: validateDate, trigger:'change'}]
      }
    }
  },
  computed:{
    tag() {
      return this.$store.state.tagsView.visitedViews.find(tag => {
        return tag.path===this.$route.path
      });
    }
  },
  methods:{
    getFnAreaOptionLabel(){
      if(this.configAreaIsDel){
         this.formData.configAreaFid = ''
         return this.label+'(已删除)'
      } else{
         return  this.formData.projectId==='' ? '请先选择项目': (this.fnAreaList.length === 0?'暂无数据':'请选择')
      }
    },
    handleSubmit(name) {
      this.$refs[name].validate((bool) => {
          if(bool){
              this.getDateExp('initiatTime')
              this.getDateExp('qualifyDateStr')
              let projectId = this.formData.projectId
              if (!this.modify){
                addArchives(this.formData).then(res => {
                  this.$Message.success('添加成功!');
                    // this.$router.push({ name: 'filemanagement', params: { projectId: projectId }})
                    this.$router.push({ name: 'property', params: { projectId: projectId, targetTab:'2'}})
                }).catch(err => {
                    console.log(err)
                })
              } else {
                updateArchives(this.formData).then(res => {
                  this.$Message.success('修改成功!');
                    this.$router.push({ name: 'property', params: { projectId: projectId ,targetTab:'2'}})

                  //   this.$store.dispatch("delVisitedViews", this.tag).then( ()=> {
                  //   this.$router.push({ name: 'filemanagement', params: { projectId: projectId }})
                  // })
                }).catch(err => {
                    console.log(err)
                })
              }
          }else {
            this.$Message.error('输入项不合法，请按提示检查并修改成功!');
          }
      })

    },
    remoteMethod(query){
      if (query !== '' && this.formData.projectId !=='') {
        this.loading = true;
        let params = {
          projectid:this.formData.projectId,
          roomnumber:query
        }
        fuzzyRoom(params).then( res => {
          this.loading = false;
          this.roomList = res.data;
        })
      } else {
          this.roomList = [];
          this.formData.configAreaFid=''
      }
    },
    setConfigAreaFid(){
      this.formData.configAreaFid = ''
      this.roomList = []
    },
    changeProject(value) {
      if(value !== ''){
        if(!this.isFirstChang){
          this.formData.configArea = ''
          this.formData.configAreaFid = ''
        }
        this.getFunctionalArea(value)
      }else{
        this.formData.configArea = ''
      }
      this.isFirstChang = false
    },
    getFunctionalArea(projectId){
      if(projectId !== ''){
        getFnByProject({projectid:projectId}).then( res => {
          if(res.data.length === 0) {
            this.fnAreaList = []
          } else{
            this.fnAreaList = res.data
          }
        })
      }
    },
    initData() {
      return new Promise((resolve, reject) => {
        goodsInfoMenu().then( res => {
          this.bigCategoryList = res.data
          if(this.formData.bigCategoryCode) {
            for (let [index, item] of this.bigCategoryList.entries()) {
              if (this.formData.bigCategoryCode === item.value) {
                  this.smallCategoryList = this.bigCategoryList[index].children;
              }
            }
          }
          getSelectedData().then( res => {
            this.channel = res.data.channel
            this.configArea = res.data.configArea
            this.goodsBelong = res.data.goodsBelong
            this.isFixed = res.data.isFixed
            this.telecontroller = res.data.telecontroller
            getBuildInfo().then(res => {
              this.projectList = res.data
              if(this.formData.projectId){
                this.getFunctionalArea(this.formData.projectId)
              }
              getSuppliers().then(res => {
                this.supplierList = res.data
                if(this.formData.configVendorCode) {
                  getBrand({configVendorCode:this.formData.configVendorCode}).then( res => {
                    this.brandList = res.data
                  })
                }
              })
              resolve();
            })
          })
        })
      })
    },
    changeBigCategory(obj) {
      this.formData.bigCategoryName = obj.label
      let value = obj.value
      for (let [index, item] of this.bigCategoryList.entries()) {
        if (value === item.value) {
            this.smallCategoryList = this.bigCategoryList[index].children;
        }
      }
      if(!this.formData.bigCategoryCode){
        this.smallCategoryList=[]
      }
      this.goodsList=[]
    },
    changeSmallCategory(obj) {
      this.formData.smallCategoryName = obj.label
      let value = obj.value
      if(!this.formData.smallCategoryCode){
        this.goodsList=[]
      } else{
        goodsInfoList({bigGoodsCode:this.formData.bigCategoryCode,smallGoodsCode:value})
          .then( res => {
            this.goodsList = res.data
        })
      }
    },
    changeSupplier(venderObj) {
      this.formData.configVendorName = venderObj.label
      let value = venderObj.value
      if(!this.formData.configVendorCode){
        this.brandList=[]
      } else{
        getBrand({configVendorCode:value}).then( res => {
          this.brandList = res.data
        })
      }
    },
    getGoodsName(goodsObj) {
      this.formData.goodsName = goodsObj.label
    },
    getDateExp(ref) {
      if(typeof this.formData[ref]==='object'){
        this.formData[ref] = this.$refs[ref].publicStringValue
      }
    },
    closeTag() {
        this.$router.push({ name: 'property', params: { projectId: projectId ,targetTab:'2'}})
      // this.$store.dispatch("delVisitedViews", tag).then( ()=> {
      //   this.$router.push({ name: 'filemanagement', params: { projectId: projectId }})
      // })
    }
  }
}
</script>

<style lang="css" scoped>
 .item-width {
   width:300px;
 }
 .wd80{
   width: 80px;
 }
  .wd216{
   width: 216px;
 }
</style>
